// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.header {
  color: #0b2d71;
  font-weight: bolder;
  margin-bottom: 0;
}

hr {
  color: #0b2d71;
  border-top: 0.1em solid;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.data-container {
  margin-top: 4%;
}

.notes-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 2em;
}

.notes-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-grow: 2;
  align-content: stretch;
  gap: 15px;
  text-align: justify;
}

.legend-container {
  display: flex;
  flex-direction: row;
}

#legend-table td {
  font-size: 12pt;
  font-family: "Gotham", Arial, sans-serif;
  padding: 8px 4px;
  vertical-align: top;
}
#legend-table .legend-code-cell {
  white-space: nowrap;
  font-weight: 500;
}
#legend-table .legend-separator-cell {
  padding: 8px 8px;
}
#legend-table .legend-description-cell {
  width: 100%;
}
#legend-table .description-with-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  width: 100%;
}
#legend-table .description-text {
  line-height: 1.5;
}
#legend-table .legend-actions {
  display: flex;
  align-items: flex-start;
  flex-shrink: 0;
  margin-top: -4px;
}
#legend-table .legend-actions .edit-legend-notes-btn {
  min-width: auto;
  width: 36px;
  height: 36px;
  padding: 0;
}
#legend-table .legend-actions .edit-legend-notes-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
#legend-table .legend-actions .edit-legend-notes-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
#legend-table .readonly-chip {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  min-height: 24px;
  padding: 4px 10px;
  background-color: #e3f2fd;
  color: #1976d2;
  border: 1px solid #90caf9;
  border-radius: 16px;
  cursor: help;
  transition: all 0.2s ease;
}
#legend-table .readonly-chip:hover {
  background-color: #bbdefb;
  border-color: #64b5f6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
#legend-table .editable-chip {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  min-height: 24px;
  padding: 4px 10px;
  background-color: #f3e5f5;
  color: #7b1fa2;
  border: 1px solid #ce93d8;
  border-radius: 16px;
  cursor: help;
  transition: all 0.2s ease;
}
#legend-table .editable-chip:hover {
  background-color: #e1bee7;
  border-color: #ba68c8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
